module.exports = __webpack_public_path__ + "img/mobile.9d127646.png";